import Routers from './router'
import purchaseStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('purchaseMudule', purchaseStore)
	}
}